import React, {ReactNode} from 'react';
import {TableInstance} from 'react-table';
import styled from 'styled-components';

import {Renderer} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {TableGlobalFilter} from './tableGlobalFilter';

/*
 * Props.
 */

interface TableTitleBarProps<T extends object> {
  title?: ReactNode;
  instance: TableInstance<T>;
  renderCustom?: Renderer;
  renderColumnPicker?: Renderer;
  renderExportSelector?: Renderer;
}

/*
 * Styles.
 */

const StyledTableTitleBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 11px 0;
`;

const StyledTableTitle = styled.div`
  font-size: ${fontSizes.large};
  color: ${(p) => p.theme.greys.shade80};
  font-weight: ${fontWeights.bold};
`;

const StyledTitleRightPart = styled.div`
  display: flex;
`;

/*
 * Component.
 */

export const TableTitleBar = <T extends object>({
  renderCustom,
  renderColumnPicker,
  renderExportSelector,
  title,
  instance,
}: TableTitleBarProps<T>) => {
  const {
    preGlobalFilteredRows,
    setGlobalFilter,
    state: {globalFilter},
  } = instance;

  return (
    <StyledTableTitleBar>
      <StyledTableTitle>{title}</StyledTableTitle>
      <StyledTitleRightPart>
        {renderCustom && renderCustom()}
        <TableGlobalFilter<T>
          preGlobalFilteredRows={preGlobalFilteredRows}
          globalFilter={globalFilter}
          setGlobalFilter={setGlobalFilter}
        />
        {renderExportSelector && renderExportSelector()}
        {renderColumnPicker && renderColumnPicker()}
      </StyledTitleRightPart>
    </StyledTableTitleBar>
  );
};
